export interface RawCountryProperties {
  ADMIN?: string;
  NAME?: string;
  NAME_LONG?: string;
  FORMAL_EN?: string;
  ISO_A3?: string;
  ISO_A3_EH?: string;
  ADM0_A3?: string;
  CONTINENT?: string;
  REGION_UN?: string;
  SUBREGION?: string;
  POP_EST?: number;
  LABEL_X?: number;
  LABEL_Y?: number;
}

const UNASSIGNED = "-99";

export const resolveIso = (props: RawCountryProperties): string => {
  const iso = props.ISO_A3;
  if (iso && iso !== UNASSIGNED) return iso;
  const isoEh = props.ISO_A3_EH;
  if (isoEh && isoEh !== UNASSIGNED) return isoEh;
  const adm0 = props.ADM0_A3;
  if (adm0 && adm0 !== UNASSIGNED) return adm0;
  return "UNK";
};
